<template>

  <v-container fluid class="pa-0" v-if="notifications && notifications.length > 0">

    <!------------------------------------>
    <!-- Unread Messages from Receivers -->
    <!------------------------------------>
    <v-container fluid class="py-4 ma-0 order-shipper-message-notifications">
      <v-row>
        <v-col cols="12">
          <div class="align-center justify-s">
            <div class="d-flex align-center justify-center">
              <v-icon style="font-size:24px;" color="amber darken-1" class="mr-4">mdi-message-text-outline</v-icon>
              <span class="action-title" v-if="notifications.length === 1">You have 1 unread message from a Receiver</span>
              <span class="action-title" v-else>You have {{ notifications.length }} unread messages from Receivers</span>
            </div>
            <template v-if="notifications.length > 0">
              <div class="d-flex align-center justify-center mt-3">
                <v-btn text color="#d9d9d9" @click="showNotifications = !showNotifications">
                  <span class="mr-1">Orders with messages</span>
                  <v-icon v-if="!showNotifications">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
              </div>
              <transition name="slide-down" appear>
                <div style="max-width:840px;margin: 0 auto;" class="mb-4 mt-0 pl-4 more-info-text" v-if="showNotifications">
                  <v-row class="mt-2" align="center" justify="center">
                    <v-col cols="3">
                      <div class="notification-header-text">Order #</div>
                    </v-col>
                    <v-col cols="5" class="d-flex align-center justify-center">
                      <div class="notification-header-text">Messages</div>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                      <div class="notification-header-text">Location</div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-for="(order, index) in ordersWithNotifications" :key="`order-messages-${index}`">
                    <v-col cols="3" class="d-flex align-center">
                      <router-link class="item-link" :to="generateOrderInfoPageLink(order)">
                        <span class="order-number">{{ order.order_number }}</span>
                      </router-link>
                    </v-col>
                    <v-col cols="5" class="d-flex align-center justify-center">
                      <div class="unread-message-count-text">{{ getNotificationCount(order) }} Unread</div>
                      <router-link :to="generateOrderMessagesPageLink(order)">
                        <v-btn small outlined color="amber darken-1" class="ml-8">
                          <v-icon small style="padding-right:8px;">mdi-message-text-outline</v-icon>
                          View Messages
                        </v-btn>
                      </router-link>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                      <router-link class="item-link" :to="generateReceiverLocationPageLink(order.receiver)">
                        <span class="location-name">{{ order.receiver.name }}</span>
                      </router-link>
                    </v-col>
                  </v-row>
                </div>
              </transition>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>

</template>

<script>
export default {
  name: 'OrderShipperMessageNotifications',

  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      showNotifications: false
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    ordersWithNotifications () {
      // Build distinct map of orders with messages
      const uniqueOrders = this.notifications.reduce((acc, notification) => {
        if (notification.order && notification.order.id) {
          acc[notification.order.id] = notification.order
        }
        return acc
      }, {})

      // Return as array
      return Object.values(uniqueOrders)
    }
  },

  methods: {
    formatDate (date) {
      return (date) ? this.$root.utils.dateFormat(date, 'MMMM D, YYYY') : ''
    },

    // Generate link data for order info page
    generateOrderInfoPageLink (order) {
      if (order && order.id) {
        return {
          name: 'order-info-overview',
          params: { orderId: order.id }
        }
      } else {
        return ''
      }
    },

    // Generate link data for order messages page
    generateOrderMessagesPageLink (order) {
      if (order && order.id) {
        return {
          name: 'order-info-messages',
          params: { orderId: order.id }
        }
      } else {
        return ''
      }
    },

    // Generate link data for receiver item page
    generateReceiverLocationPageLink (receiver) {
      if (receiver && receiver.id) {
        return {
          name: 'receiver-item',
          params: { receiverId: receiver.id }
        }
      } else {
        return ''
      }
    },

    // Get notifications for the provided order
    getNotificationCount (order) {
      if (!order || !order.id) return 0
      return (this.notifications && this.notifications.length > 0)
        ? this.notifications.filter(it => it.order_id === order.id).length
        : 0
    }
  }
}
</script>

<style scoped>
  a.item-link {
    text-decoration: none;
  }

  a.item-link:hover {
    text-decoration: underline;
  }

  .order-shipper-message-notifications {
    border: 1px solid #FF9D29;
    border-radius: 4px;
  }

  .order-shipper-message-notifications .action-title {
    font-size: 1.3rem;
    font-weight: 500;
  }

  .order-shipper-message-notifications .order-number {
    font-size: 1.08rem;
  }

  .order-shipper-message-notifications .location-name {
    font-size: 1.0rem;
  }

  .order-shipper-message-notifications .unread-message-count-text {
    font-size: 0.96rem;
    color: #9c9c9c;
  }

  .order-shipper-message-notifications .more-info-text {
    color: #ffffff;
  }

  .order-shipper-message-notifications .notification-header-text {
    color: #727272;
  }

  /* Add these transition styles at the end of your style block */
  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: all 0.3s ease;
    max-height: 1000px; /* Adjust this value based on your content's maximum height */
  }

  .slide-down-enter-from,
  .slide-down-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }
</style>
